import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { css, cx } from 'emotion';
import AbstractForm from 'components/page/process/AbstractForm';
import ProcessUtils from 'utils/ProcessUtils';
import MissingValueParameter from 'components/core/fields/transformation_parameters/MissingValueParameter';
import QCMaskParameter from 'components/core/fields/transformation_parameters/QCMaskParameter';
import QCBadParameter from 'components/core/fields/transformation_parameters/QCBadParameter';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import InfoMessages from 'components/core/help/InfoMessages';
import { colorBorderGrey } from 'styles/base';

const formStyles = css`
    background-color: #fff;
    padding: 8px 15px;
    margin-bottom:15px;
`;

/**
 * The form that renders details for an output datastream
 */
export default class InputQCForm extends AbstractForm {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        exploredDatastreams: PropTypes.object,
        className: PropTypes.string,
        border: PropTypes.bool
    };

    shouldSectionBeDisplayed(parameters) {
        let shouldDisplay = false;
        parameters.forEach(parameterName => {
            shouldDisplay = shouldDisplay || this.shouldParameterBeDisplayed(parameterName);
        });
        return shouldDisplay;
    }

    shouldParameterBeDisplayed(parameterName) {
        let isRelevant = false;
        ProcessUtils.visitDimensions(this.props.process, (dimension, coordinateSystemName) => {
            isRelevant = isRelevant || ProcessUtils.isRelevantTransformationParameter(this.props.process, parameterName,
                [coordinateSystemName], dimension.name, this.props.exploredDatastreams);
        });
        return isRelevant;
    }

    renderBadValueInfoMessage() {
        const showQCBad = this.shouldParameterBeDisplayed('qc_bad');
        const showQCMask = this.shouldParameterBeDisplayed('qc_mask');
        if (showQCBad && showQCMask) {
            return (
                <Flexbox flexDirecton="column">
                    {InfoMessages.qcMask}
                    {InfoMessages.qcBad}
                </Flexbox>
            );
        } else if (showQCBad) {
            return InfoMessages.qcBad;

        } else if (showQCMask) {
            return InfoMessages.qcMask;
        }
        return '';
    }

    render() {
        const displayMissingValueSection = this.shouldSectionBeDisplayed(['missing_value']);
        const displayQCSection = this.shouldSectionBeDisplayed(['qc_mask', 'qc_bad']);

        let wrapperStyle = css`
            background-color: #fff;
            padding: 8px 15px;
            .infobox {
                align-self: flex-start !important;
            }
        `;
        if (this.props.border) {
            wrapperStyle = cx(wrapperStyle, css`border: 1px solid ${colorBorderGrey};`);
        }

        return (
            <Flexbox flexGrow={1} flexDirection={'column'} className={cx('input-qc-form', wrapperStyle, this.props.className)}>
                <Flexbox flexDirection={'column'}>
                    <InfoBoxLabel label="Interpreting Missing Values in the Input Data"/>
                    <Flexbox className={cx('missing-value-section', formStyles)} flexDirection={'column'}>
                        <MissingValueParameter
                            process={this.props.process}
                            processErrors={this.props.processErrors}
                            exploredDatastreams={this.props.exploredDatastreams}
                            hasWritePermissions={this.props.hasWritePermissions}
                        />
                    </Flexbox>
                </Flexbox>
                <Flexbox flexDirection={'column'}>
                    <InfoBoxLabel label="Interpreting Bad Values in the Input Data" message={this.renderBadValueInfoMessage()}/>
                    <Flexbox className={cx('qc-section', formStyles)} flexDirection={'column'}>
                        <QCMaskParameter
                            process={this.props.process}
                            processErrors={this.props.processErrors}
                            exploredDatastreams={this.props.exploredDatastreams}
                            hasWritePermissions={this.props.hasWritePermissions}
                        />
                        <QCBadParameter
                            process={this.props.process}
                            processErrors={this.props.processErrors}
                            exploredDatastreams={this.props.exploredDatastreams}
                            hasWritePermissions={this.props.hasWritePermissions}
                        />
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/forms/InputQCForm.js